import {
  QUERY_RESPONSE_RECEIVED,
  MUTATION_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import { SEARCH_PARAMS_CHANGED } from '@web-platform/shared-universal-constants/src/userSearch';
import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';
import {
  getFlightsResponseBody,
  isResponseContainFlightsBody,
  isFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import keyBy from 'lodash/keyBy';

import { mapItineraries } from './itinerariesMapper';

import type {
  MutationResponseAction,
  QueryResponseAction,
  Action,
} from '@web-platform/shared-universal-types/src/redux/actions/actions-shared-types';
import type {
  ItineraryState,
  Itinerary,
  ItineraryById,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';

export type {
  Itinerary,
  ItineraryPricingOption,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';
export const INITIAL_STATE: ItineraryState = {
  byId: {},
};

const byId = (state: ItineraryById, action: MutationResponseAction | QueryResponseAction) => {
  switch (action.payload.type) {
    case RADAR_CREATE_SESSIONS:
    case RADAR_POLL: {
      if (
        isFlightsResponseError(action.payload.response) ||
        !isResponseContainFlightsBody(action.payload.response)
      ) {
        return state;
      }

      const flightsResponseBody = getFlightsResponseBody(action.payload.response);

      const itineraries = mapItineraries(flightsResponseBody.results || []);

      const mergedItineraries: Itinerary[] = itineraries.map((itinerary) => ({
        valid: true,
        ...itinerary,
      }));

      const useToken = getFeatureDecision(FEATURE_DECISION_KEYS.USE_ITINERARY_TOKEN);
      const newItinerariesById: ItineraryById = keyBy(mergedItineraries, (itinerary) =>
        useToken ? (itinerary.token ?? itinerary.id) : itinerary.id,
      );

      return { ...state, ...newItinerariesById };
    }

    default:
      return state;
  }
};

const itinerariesReducer = (
  state: ItineraryState = INITIAL_STATE,
  action: Action,
): ItineraryState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      const newById = byId(state.byId, action);
      if (newById === state.byId) return state;
      return { byId: newById };
    }

    case SEARCH_PARAMS_CHANGED:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default itinerariesReducer;
